"use client"

import { useEffect } from "react"

/**
 * Server → client bridge that signals a Page: Landing route to the site
 * navigation.
 *
 * The site navigation lives in the shared root layout (client component),
 * so it can't statically know the page's content type. Instead we mount
 * this tiny marker from `renderPage.tsx` only when the resolved page is
 * a `pageLanding` entry. It sets a stable data attribute on <html> that
 * `FormatSiteNavigation` reads inside its scroll handler to switch to
 * the landing-page scroll rule (nav shown at top / while scrolling down,
 * hidden while scrolling up).
 *
 * Using a data attribute on <html> (rather than context / a prop) keeps
 * the site nav decoupled from the page-content tree, works during
 * client-side navigations between landing and non-landing pages (the
 * marker mounts/unmounts as pages change), and needs no re-render of
 * the nav to take effect — the scroll handler simply re-reads the
 * current value on every scroll tick.
 */
export const PAGE_BEHAVIOR_ATTR = "pageBehavior"
export const PAGE_BEHAVIOR_LANDING = "landing"

export default function LandingPageBehaviorMarker() {
  useEffect(() => {
    if (typeof document === "undefined") return
    const previous = document.documentElement.dataset[PAGE_BEHAVIOR_ATTR]
    document.documentElement.dataset[PAGE_BEHAVIOR_ATTR] = PAGE_BEHAVIOR_LANDING
    return () => {
      if (previous == null) {
        delete document.documentElement.dataset[PAGE_BEHAVIOR_ATTR]
      } else {
        document.documentElement.dataset[PAGE_BEHAVIOR_ATTR] = previous
      }
    }
  }, [])

  return null
}
